import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TimeDkeyEaseHoldIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M2.994 21C2.58 21 2.35 20.554 2.611 20.254L9.528 12.287C9.671 12.122 9.671 11.877 9.528 11.712L2.61 3.746C2.35 3.446 2.579 3 2.993 3H20.499C20.775 3 20.999 3.224 20.999 3.5V20.5C20.999 20.776 20.775 21 20.499 21H2.994Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TimeDkeyEaseHoldIcon.displayName = 'TimeDkeyEaseHoldIcon';
